import React, { useMemo } from "react";
import { Link, Outlet } from "react-router-dom";
import { Layout } from "@arco-design/web-react";
import "./index.less";
import Header from "@/components/UI/Header";
import Menu from "@/components/UI/Menu";
import appStore from "@/stores/appStore";
import { observer } from "mobx-react";
const Content = Layout.Content;
const App = () => {

  const styles = useMemo(() => {
    return {
      background: !appStore.isOdm
        ? "linear-gradient(180deg, #e3ebff 0%, #efe2ff 97%)"
        : "linear-gradient( 180deg, #DFEAFF 0%, #F9FBFF 100%)",
    };
  }, [appStore.isOdm]);

  return (
    <div className="layout-collapse-demo" style={styles}>
      <Header />
      <Layout>
        <div className="layout_sider">
          <Menu />
        </div>
        <Content className="content_box">
          <Outlet />
        </Content>
      </Layout>
    </div>
  );
};

export default observer(App);
